/**
 * WhatsApp Business messaging adapter — REAL implementation.
 *
 * Nunca llama a GHL directamente. Llama a una ruta relativa (`/api/messaging/send`)
 * que en desarrollo local resuelve el proxy de craco.config.js (que inyecta el
 * token del backend server-side — el bundle del navegador nunca lo conoce) y en
 * producción debe resolver al mismo patrón (reverse proxy / backend sirviendo
 * el frontend). Ver TRUST_BOUNDARY.md.
 *
 * Nunca marca un envío como exitoso salvo que el backend (y, detrás, GHL)
 * confirme `ok: true`.
 */
export function createWhatsappMessaging() {
  return {
    async availableChannels() {
      return ["whatsapp"];
    },
    async channelStatus() {
      return { status: "connected" };
    },
    async send({ actor, body }) {
      const contactId = actor?.externalRefs?.ghlContactId;
      if (!contactId) {
        // No es un fallo de GHL — este actor todavía no tiene el
        // identificador externo vinculado. No se intenta el envío.
        return { ok: false, error: "missing_contact_id" };
      }
      try {
        const res = await fetch("/api/messaging/send", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ contactId, channel: "whatsapp", message: body }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) {
          return { ok: false, error: data.error || "send_failed" };
        }
        return {
          ok: true,
          providerMessageId: data.providerMessageId,
          conversationId: data.conversationId,
        };
      } catch (e) {
        return { ok: false, error: "network_error" };
      }
    },
  };
}
